<template>
  <div>
    <div class="block block-rounded block-fx-shadow">
      <div class="block-header">
        <h3 class="block-title"><font-awesome-icon icon="phone" rotation="90" /> {{ $t('phones.index') }}</h3>
        <div class="block-options">
            <b-btn v-b-modal.addphone size="sm" variant="primary" class="float-right">{{ $t('phones.add') }}</b-btn>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <th>#</th>
            <th>{{ $t('app.type') }}</th>
            <th>{{ $t('phones.phone') }}</th>
            <th>{{ $t('phones.last_contact') }}</th>
            <th>{{ $t('phones.created_at') }}</th>
            <th>{{ $t('app.action') }}</th>
          </thead>
          <tbody>
            <template v-if="!isProcessing">
              <tr v-for="(phone, index) in phones" :key="phone.id">
                <td>{{ index+1 }}</td>
                <td>{{ phone.type ? phone.type.name : 'Не определен' }}</td>
                <td>{{ phone.phone }}</td>
                <td>{{ phone.last_contact | datetimeFormat}}</td>
                <td>{{ phone.created_at | datetimeFormat}}</td>
                <td>
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm d-inline">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button @click.prevent="handleDelete(phone.id)" class="btn btn-danger btn-sm " :disabled="isProcessing">
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="isProcessing">
              <td colspan="6" class="text-center">
                <div class='sk-wave'>
                  <div class='sk-rect sk-rect-1'></div>
                  <div class='sk-rect sk-rect-2'></div>
                  <div class='sk-rect sk-rect-3'></div>
                  <div class='sk-rect sk-rect-4'></div>
                  <div class='sk-rect sk-rect-5'></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      id="addphone"
      size="lg"
      :title="$t('phones.add_title')"
      ref="modalAddPhone"
      @ok="handleStore"
      :ok-title="$t('buttons.ok')"
      :cancel-title="$t('buttons.cancel')"
      >
        <div class="form-group">
          <label for="StorePhone" class="col-form-label">{{ $t('phones.phone') }}</label>
          <input type="text" class="form-control" v-mask="phonemask" v-model="phone.phone" :class="{'is-invalid': errors.phone }" id="StorePhone">
          <span v-if="errors.phone" class="invalid-feedback">
              <strong>{{ errors.phone ? errors.phone[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreType" class="col-form-label">{{ $t('app.type') }}</label>
          <select v-model="phone.type_id" class="form-control" id="StoreType">
            <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
            <option v-for="type in adminListPhoneTypes" :value="type.id" :key="type.id" >
              {{ type.name }}
            </option>
          </select>
        </div>
    </b-modal>

    <b-modal
      id="updphone"
      size="lg"
      :title="$t('phones.edit_title')"
      ref="modalUpdatePhone"
      @ok="handleUpdate"
      @shown="fetchPhones"
      :ok-title="$t('buttons.save')"
      :cancel-title="$t('buttons.cancel')"
      >
        <div class="form-group">
          <label for="updatePhone" class="col-form-label">{{ $t('phones.phone') }}</label>
          <input type="text" class="form-control" v-mask="updatephonemask" v-model="update_phone.phone" :class="{'is-invalid': update_errors.phone }" id="updatePhone">
          <span v-if="update_errors.phone" class="invalid-feedback">
              <strong>{{ update_errors.phone ? update_errors.phone[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="updateType" class="col-form-label">{{ $t('app.type') }}</label>
          <select v-model="update_phone.type_id" class="form-control" id="updateType" >
            <option v-for="type in adminListPhoneTypes" :value="type.id" :key="type.id" :selected="update_phone.type_id == type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      phones: [],
      phone: {
        phone: '',
        type_id: '',
        status_id: '',
      },
      update_phone: {},
      errors: [],
      update_errors: [],
      isProcessing: false,
      phonemask: {
        mask: '+7(###) ###-####',
        autoUnmask: true,
        showMaskOnHover: false,
      },
      updatephonemask: {
        mask: '#(###) ###-####',
        autoUnmask: true,
        showMaskOnHover: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
      'adminListPhoneTypes',
    ]),
  },
  mounted() {
    this.fetchPhones();
    this.GET_ADMIN_LIST_PHONE_TYPES();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_PHONE_TYPES',
    ]),
    fetchPhones() {
      this.isProcessing = true;
      window.axios.get(`/admin/debtors/${this.$route.params.id}/phones`)
        .then((res) => {
          this.phones = res.data.phones;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.phone.phone = '';
      this.phone.type_id = '';
      this.phone.status_id = '';
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_phone = {};
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdatePhone.show();
      this.update_phone = this.phones[index];
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updatePhone();
      this.isProcessing = true;
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storePhone();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deletePhone(id);
        }
      });
    },

    storePhone() {
      window.axios.post(`/admin/debtors/phones/${this.$route.params.id}`, this.phone)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddPhone.hide();
            this.clearModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchPhones();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updatePhone() {
      window.axios.put(`/admin/debtors/phones/${this.update_phone.id}`, this.update_phone)
        .then((res) => {
          if (res.status === 200) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.$refs.modalUpdatePhone.hide();
            this.fetchPhones();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deletePhone(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/debtors/phones/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchPhones();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
